import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar } from "lucide-react";

export default function News() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/news").then((r) => setItems(r.data)).catch(() => {});
    }, []);
    return (
        <div data-testid="news-page">
            <section className="bg-ink text-white py-24 md:py-28">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                    <div className="overline text-primary mb-4">News & Updates</div>
                    <h1 className="font-display text-5xl md:text-7xl font-bold leading-[1] tracking-tight">
                        The latest from Peppa Target.
                    </h1>
                </div>
            </section>
            <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
                {items.length === 0 ? (
                    <div className="bg-surface border border-border p-8 text-center text-muted-foreground">No news yet.</div>
                ) : (
                    <div className="grid md:grid-cols-3 gap-6">
                        {items.map((n) => (
                            <Link key={n.id} to={`/news/${n.slug}`} className="group bg-white border border-border hover:border-primary transition-all" data-testid={`news-item-${n.slug}`}>
                                <div className="aspect-[16/10] overflow-hidden">
                                    <img src={n.image_url} alt={n.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                                </div>
                                <div className="p-6">
                                    <div className="text-[10px] uppercase tracking-wider text-primary font-semibold mb-2">{n.category}</div>
                                    <h3 className="font-display font-bold text-lg leading-snug mb-3">{n.title}</h3>
                                    <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3 mb-3">{n.excerpt}</p>
                                    <div className="text-xs text-muted-foreground flex items-center gap-2">
                                        <Calendar className="w-3 h-3" />
                                        {new Date(n.created_at).toLocaleDateString()}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
